import { OccupantContact } from '@centecomm/portal-service';

export enum ContactActions {
    ADD_OCCUPANT_CONTACTS = 'ADD_OCCUPANT_CONTACTS',
    ADD_PROPERTY_CONTACTS = 'ADD_PROPERTY_CONTACTS',
    DELETE_PROPERTY_CONTACTS = 'DELETE_PROPERTY_CONTACTS',
    UPDATE_PROPERTY_CONTACTS = 'UPDATE_PROPERTY_CONTACTS',
    CREATE_PROPERTY_CONTACTS = 'CREATE_PROPERTY_CONTACTS',
    LOAD_USER_CONTACTS = 'LOAD_USER_CONTACTS',
    SET_USER_CONTACTS = 'SET_USER_CONTACTS',
}

interface AddOccupantContactsAction {
    type: typeof ContactActions.ADD_OCCUPANT_CONTACTS;
    payload: {
        occupantId: number | string;
        contacts: OccupantContact[];
    };
}

interface AddPropertyContactsAction {
    type: typeof ContactActions.ADD_PROPERTY_CONTACTS;
    payload: {
        propertyId: number | string;
        contacts: OccupantContact[];
    };
}

interface LoadUserContactsAction {
    type: typeof ContactActions.LOAD_USER_CONTACTS;
}

interface SetUserContactsAction {
    type: typeof ContactActions.SET_USER_CONTACTS;
    payload: OccupantContact[];
}

export type ContactActionTypes =
    | AddOccupantContactsAction
    | AddPropertyContactsAction
    | LoadUserContactsAction
    | SetUserContactsAction;
